import React from "react";
import { Box, BoxProps, Chip, Tooltip } from "@mui/material";
import DifficultyChip from "./DifficultyChip";
import GenreChip from "./GenreChip";
import { QuestionType, ClaimType, QUESTION_TYPE_LABELS, CLAIM_TYPE_LABELS } from "../../types";

interface TopicBadgesProps {
  difficulty?: number;
  genre?: string;
  questionType?: QuestionType;
  claimType?: ClaimType;
  sx?: BoxProps["sx"];
}

/**
 * 難易度、ジャンル、問題タイプのバッジを表示する共通コンポーネント
 */
const TopicBadges: React.FC<TopicBadgesProps> = ({
  difficulty,
  genre,
  questionType,
  claimType,
  sx,
}) => {
  const hasDifficulty = difficulty !== undefined && difficulty > 0;
  const hasGenre = Boolean(genre);
  const hasQuestionType = Boolean(questionType);

  if (!hasDifficulty && !hasGenre && !hasQuestionType) return null;

  return (
    <Box sx={{ display: "inline-flex", flexWrap: "wrap", gap: 0.5, ...sx }}>
      {hasDifficulty && <DifficultyChip difficulty={difficulty} />}
      {hasGenre && <GenreChip genre={genre!} />}
      {hasQuestionType && questionType && (
        <Tooltip title={QUESTION_TYPE_LABELS[questionType]}>
          <Chip label={QUESTION_TYPE_LABELS[questionType]} size="small" variant="outlined" />
        </Tooltip>
      )}
      {hasQuestionType && questionType === "claim" && claimType && (
        <Tooltip title={`主張タイプ: ${CLAIM_TYPE_LABELS[claimType]}`}>
          <Chip label={CLAIM_TYPE_LABELS[claimType]} size="small" variant="outlined" color="info" />
        </Tooltip>
      )}
    </Box>
  );
};

export default TopicBadges;
